import type { SceneContext } from "@excalidraw/element";

/**
 * The context list (`appState.sceneContexts`) is kept in its own localStorage
 * key, on top of the app-state key. A build without the contexts feature
 * (upstream, or an older one) opened on the same origin rewrites the
 * app-state key with only the fields it knows, dropping the list — but it
 * never touches this key, so the names and colours survive.
 */
const LOCAL_STORAGE_SCENE_CONTEXTS = "canvas-scene-contexts";

export const saveSceneContextsToLocalStorage = (
  sceneContexts: readonly SceneContext[],
) => {
  localStorage.setItem(
    LOCAL_STORAGE_SCENE_CONTEXTS,
    JSON.stringify(sceneContexts),
  );
};

/** `null` when the key is missing or unreadable */
export const importSceneContextsFromLocalStorage = ():
  | SceneContext[]
  | null => {
  try {
    const data = localStorage.getItem(LOCAL_STORAGE_SCENE_CONTEXTS);
    if (data) {
      const sceneContexts = JSON.parse(data);
      if (Array.isArray(sceneContexts)) {
        return sceneContexts;
      }
    }
  } catch (error: any) {
    // Unable to access localStorage, or malformed data
    console.error(error);
  }
  return null;
};
